import {
  FROM_X_TO_Y_PROMOTION,
  TAKE_X_PAY_Y_PROMOTION,
  VAREJO_ATACADO_PROMOTION,
} from "../../CanvasViewer/EncarteConstants.js";
import { PAYMENT_METHODS } from "../../../sharable/PaymentMethodsList.jsx";

const HASHTAG = "#feitocomfertasexpress";

export const CAPTION_TOGGLE_OPTIONS = [
  { key: "products", label: "Produtos" },
  { key: "address", label: "Endereço" },
  { key: "contacts", label: "Contatos" },
  { key: "payments", label: "Formas de pagamento" },
  { key: "delivery", label: "Entrega" },
];

export const DEFAULT_CAPTION_TOGGLES = CAPTION_TOGGLE_OPTIONS.reduce(
  (acc, { key }) => {
    acc[key] = true;
    return acc;
  },
  {},
);

function stripFileExtension(name) {
  if (!name) return "";
  return name.replace(/\.[^/.]+$/, "");
}

function buildAddressLine(address) {
  if (!address) return "";
  const streetPart = [address.street, address.number]
    .filter(Boolean)
    .join(", ");
  const localityPart = [address.neighborhood, address.city]
    .filter(Boolean)
    .join(", ");
  return [streetPart, localityPart].filter(Boolean).join(" - ");
}

function buildContactsLines(social) {
  if (!social) return [];
  const lines = [];
  if (social.whatsapp) lines.push(`WhatsApp: ${social.whatsapp}`);
  if (social.instagram) lines.push(`Instagram: ${social.instagram}`);
  if (social.facebook) lines.push(`Facebook: ${social.facebook}`);
  if (social.website) lines.push(`Site: ${social.website}`);
  if (lines.length === 0) return [];
  return ["Conheça todas as nossas redes sociais:", ...lines];
}

function buildIntroLines(promoName, storeName, phrase) {
  const lines = [];
  if (promoName && storeName)
    lines.push(`Chegou o "${promoName}" no ${storeName}. Corre pra cá!`);
  else if (promoName) lines.push(`Chegou o "${promoName}". Corre pra cá!`);
  else if (storeName) lines.push(storeName);
  if (phrase) lines.push(phrase);
  return lines;
}

function formatDate(date) {
  if (!date) return "";
  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d.getTime())) return "";
  return d.toLocaleDateString("pt-BR");
}

function buildValidadeLine(startDate, endDate) {
  const start = formatDate(startDate);
  const end = formatDate(endDate);
  if (start && end) return `Válido de ${start} até ${end}.`;
  if (end) return `Válido até ${end}.`;
  if (start) return `Válido a partir de ${start}.`;
  return "";
}

function buildPaymentsLine(paymentMethods) {
  if (!Array.isArray(paymentMethods) || paymentMethods.length === 0) return "";
  const labels = paymentMethods
    .map((id) => PAYMENT_METHODS.find((pm) => pm.id === id)?.label)
    .filter(Boolean);
  if (labels.length === 0) return "";
  return `Aqui você paga como preferir 💳: ${labels.join(", ")}`;
}

function formatProductLine(product) {
  const measurement = product.measurement ? ` (${product.measurement})` : "";
  const prefix = `- ${product.name}${measurement}`;

  switch (product.promotionType) {
    case FROM_X_TO_Y_PROMOTION:
      return `${prefix} - De R$ ${product.normalSellingPrice} por R$ ${product.promotionPrice}`;
    case TAKE_X_PAY_Y_PROMOTION:
      return product.payY
        ? `${prefix} - Leve ${product.takeX}, pague ${product.payY} por R$ ${product.promotionPrice}`
        : `${prefix} - Leve ${product.takeX} por R$ ${product.promotionPrice}`;
    case VAREJO_ATACADO_PROMOTION:
      return `${prefix} - Varejo R$ ${product.varejoPrice} / Atacado R$ ${product.atacadoPrice}`;
    default:
      return `${prefix} - R$ ${product.promotionPrice}`;
  }
}

function buildProductLines(products) {
  if (!Array.isArray(products)) return [];
  return products.filter((p) => p?.name).map(formatProductLine);
}

export default function buildCaptionText({
  modelName,
  userBrand,
  products,
  startDate,
  endDate,
  toggles,
}) {
  const sections = [];

  const introLines = buildIntroLines(
    stripFileExtension(modelName),
    userBrand?.name,
    userBrand?.phrase,
  );
  if (introLines.length > 0) sections.push(introLines.join("\n"));

  if (toggles.products) {
    const productLines = buildProductLines(products);
    if (productLines.length > 0) sections.push(productLines.join("\n"));
  }

  const validadeLine = buildValidadeLine(startDate, endDate);
  if (validadeLine) sections.push(validadeLine);

  if (toggles.address) {
    const addressLine = buildAddressLine(userBrand?.address);
    if (addressLine) sections.push(`📍Onde estamos? ${addressLine}`);
  }

  if (toggles.contacts) {
    const contactLines = buildContactsLines(userBrand?.social);
    if (contactLines.length > 0) sections.push(contactLines.join("\n"));
  }

  if (toggles.payments) {
    const paymentsLine = buildPaymentsLine(userBrand?.paymentMethods);
    if (paymentsLine) sections.push(paymentsLine);
  }

  if (toggles.delivery && userBrand?.deliveryAvailable)
    sections.push("Fazemos entrega! Faça agora seu pedido🛵");

  sections.push(HASHTAG);

  return sections.join("\n\n");
}
